import React from 'react'

const Hero = () => {
  return (
    <section className='hero' id='home'>
      <div className='container'>
        <h1>Innovative Software Solutions for Your Business</h1>
        <p>
          Rokyet Ventures Ltd. specializes in developing cutting-edge software
          solutions, with our flagship product AroPMIS revolutionizing property
          management.
        </p>
        <div className='hero-btns'>
          <a href='#aropmis' className='btn btn-accent'>
            Learn About AroPMIS
          </a>
          <a href='#contact' className='btn btn-secondary'>
            Get In Touch
          </a>
        </div>
      </div>
    </section>
  )
}

export default Hero
